import { Button, Modal, Spacer, Text } from '@loomhq/lens';
import React, { ReactElement } from 'react';
import ReactDOM from 'react-dom';

type Props = {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  onOverwrite: () => void;
};

const SaveConflictModal = ({
  isOpen,
  setIsOpen,
  onOverwrite,
}: Props): ReactElement => {
  return ReactDOM.createPortal(
    <Modal
      mainButton={
        <Button
          onClick={() => {
            onOverwrite();
            setIsOpen(!isOpen);
          }}
          variant="primary"
        >
          Overwrite
        </Button>
      }
      secondaryButton={
        <Button onClick={() => setIsOpen(!isOpen)}>Cancel</Button>
      }
      title={'⚠️ Save Conflict!'}
      isOpen={isOpen}
      onCloseClick={() => setIsOpen(!isOpen)}
      onBackgroundClick={() => setIsOpen(!isOpen)}
    >
      <Text>Clips or edits have changed since you started editing</Text>
      <Spacer bottom="medium" />
      <Text>
        You can choose to overwrite these changes, or refresh the page to see
        the latest (this will discard your current changes)
      </Text>
    </Modal>,
    document.body
  );
};

export default SaveConflictModal;
